export default __webpack_public_path__ + "static/media/footer_loghi.faf19716.png";